import { jsx, Fragment, jsxs } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { cx } from '@unionco/utils';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded$6 = ["children", "className", "viewBoxHeight", "viewBoxWidth", "cssClasses"];
var IconSVG = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    viewBoxHeight = _ref.viewBoxHeight,
    viewBoxWidth = _ref.viewBoxWidth,
    cssClasses = _ref.cssClasses,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var vbHeight = viewBoxHeight ? viewBoxHeight : viewBoxWidth;
  return jsx("svg", _extends({
    className: cx('b-icon', className),
    width: '100%',
    height: '100%',
    viewBox: "0 0 " + viewBoxWidth + " " + vbHeight,
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    ref: ref,
    css: cssClasses
  }, props, {
    children: children
  }));
});
IconSVG.displayName = 'IconSVG';

var _excluded$5 = ["className"],
  _excluded2$2 = ["iconDirection"];
var CaretIconDown = function CaretIconDown(_ref) {
  var className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var defaultClasses = 'b-CaretIcon';
  var classes = !className ? defaultClasses : defaultClasses + " " + className;
  return jsx(IconSVG, _extends({
    className: classes,
    viewBoxWidth: 13,
    viewBoxHeight: 6
  }, props, {
    ref: undefined,
    children: jsx("path", {
      d: 'M12.5 1.01152e-06L6.5 6L0.5 0L12.5 1.01152e-06Z',
      fill: 'currentColor'
    })
  }));
};
var CaretIcon = function CaretIcon(_ref2) {
  var _ref2$iconDirection = _ref2.iconDirection,
    iconDirection = _ref2$iconDirection === void 0 ? 'down' : _ref2$iconDirection,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2$2);
  switch (iconDirection) {
    case 'right':
      return jsx(CaretIconDown, _extends({
        style: {
          transform: 'rotate(-90deg)'
        }
      }, props));
    case 'down':
      return jsx(CaretIconDown, _extends({}, props));
    case 'left':
      return jsx(CaretIconDown, _extends({
        style: {
          transform: 'rotate(90deg)'
        }
      }, props));
    case 'up':
      return jsx(CaretIconDown, _extends({
        style: {
          transform: 'rotate(180deg)'
        }
      }, props));
    default:
      return jsx(Fragment, {});
  }
};

var _excluded$4 = ["curved"];
var CheckMarkSharp = function CheckMarkSharp(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx("svg", _extends({
    width: '100%',
    height: '100%',
    viewBox: '0 0 22 16',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props, {
    children: jsx("path", {
      d: 'M22 2.36191L19.5286 0L7.74523 11.2762L2.47138 6.22937L0 8.59129L7.74525 16L22 2.36191Z',
      fill: 'currentColor'
    })
  }));
};
var CheckMarkCurved = function CheckMarkCurved(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return jsx("svg", _extends({
    width: '100%',
    height: '100%',
    viewBox: '0 0 12 9',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props, {
    children: jsx("path", {
      d: 'M10.0612 0.000401261C9.79887 0.0109337 9.54995 0.133812 9.368 0.34445C7.43654 2.50098 5.96187 4.30196 4.16916 6.34104L2.25975 4.5435C2.05573 4.35128 1.79027 4.25738 1.52324 4.28194C1.25621 4.30739 1.00965 4.45046 0.837158 4.67865C0.664649 4.90773 0.580372 5.20264 0.604006 5.50017C0.62764 5.79771 0.756035 6.07244 0.961619 6.26377L3.58312 8.73538C3.98328 9.11105 4.57406 9.08384 4.94428 8.67219C7.11609 6.24708 8.66237 4.31001 10.7922 1.93142C11.0916 1.6093 11.1829 1.11516 11.0207 0.687701C10.8592 0.259393 10.4779 -0.0127096 10.0612 0.000457403L10.0612 0.000401261Z',
      fill: 'currentColor'
    })
  }));
};
var CheckMarkIcon = function CheckMarkIcon(_ref3) {
  var curved = _ref3.curved,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded$4);
  return curved ? jsx(CheckMarkCurved, _extends({}, props)) : jsx(CheckMarkSharp, _extends({}, props));
};

var _excluded$3 = ["className"],
  _excluded2$1 = ["className"],
  _excluded3$1 = ["className"],
  _excluded4 = ["iconDirection", "iconStyle"];
var ChevronIconUp = function ChevronIconUp(_ref) {
  var className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var classes = className ? " " + className : '';
  return jsx("svg", _extends({
    className: "b-ChevronIcon b-icon " + classes,
    viewBox: '0 0 10 5',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props, {
    children: jsx("path", {
      d: 'M2.13043 4.7779L5.16847 1.83181L8.2065 4.7779C8.51187 5.07403 9.00515 5.07403 9.31052 4.7779C9.61589 4.48178 9.61589 4.00342 9.31052 3.70729L5.71656 0.222096C5.4112 -0.0740318 4.91791 -0.0740318 4.61254 0.222096L1.01858 3.70729C0.713209 4.00342 0.713209 4.48178 1.01858 4.7779C1.32395 5.06644 1.82507 5.07403 2.13043 4.7779Z',
      fill: 'currentColor'
    })
  }));
};
var ChevronIconDown = function ChevronIconDown(_ref2) {
  var className = _ref2.className,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
  var classes = className ? " " + className : '';
  return jsx("svg", _extends({
    className: "b-ChevronIcon b-icon " + classes,
    viewBox: '0 0 10 5',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props, {
    children: jsx("path", {
      d: 'M1.88043 0.222096L4.91847 3.16819L7.9565 0.222096C8.26187 -0.0740319 8.75515 -0.0740319 9.06052 0.222096C9.36589 0.518223 9.36589 0.996583 9.06052 1.29271L5.46656 4.7779C5.1612 5.07403 4.66791 5.07403 4.36254 4.7779L0.768578 1.29271C0.463209 0.996583 0.463209 0.518223 0.768578 0.222096C1.07395 -0.0664389 1.57507 -0.0740319 1.88043 0.222096Z',
      fill: 'currentColor'
    })
  }));
};
var ChevronIconLeftThin = function ChevronIconLeftThin(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3$1);
  var classes = className ? " " + className : '';
  return jsx("svg", _extends({
    className: "b-ChevronIcon b-icon b-icon--vertical " + classes,
    viewBox: '0 0 8 14',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props, {
    children: jsx("path", {
      d: 'M6.87618 1.22148L1.09766 7L6.87618 12.7785',
      stroke: 'currentColor',
      strokeWidth: '1.5'
    })
  }));
};
var ChevronIcon = function ChevronIcon(_ref4) {
  var _ref4$iconDirection = _ref4.iconDirection,
    iconDirection = _ref4$iconDirection === void 0 ? 'up' : _ref4$iconDirection,
    _ref4$iconStyle = _ref4.iconStyle,
    iconStyle = _ref4$iconStyle === void 0 ? 'solid' : _ref4$iconStyle,
    props = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  switch (iconStyle) {
    case 'solid':
      switch (iconDirection) {
        case 'up':
          return jsx(ChevronIconUp, _extends({}, props));
        case 'down':
          return jsx(ChevronIconDown, _extends({}, props));
        case 'right':
          return jsx(ChevronIconDown, _extends({
            style: {
              transform: 'rotate(-90deg)'
            }
          }, props));
        default:
          return jsx(Fragment, {});
      }
    case 'thin':
      switch (iconDirection) {
        case 'right':
          return jsx(ChevronIconLeftThin, _extends({
            style: {
              transform: 'rotate(180deg)'
            }
          }, props));
        case 'left':
          return jsx(ChevronIconLeftThin, _extends({}, props));
        default:
          return jsx(Fragment, {});
      }
    default:
      return jsx(Fragment, {});
  }
};

var _excluded$2 = ["weight"];
var CloseIconSolid = function CloseIconSolid(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(IconSVG, _extends({
    viewBoxWidth: 48
  }, props, {
    ref: undefined,
    children: jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.02923 40.9704C-2.33852 31.6026 -2.33852 16.397 7.02923 7.02923C16.397 -2.33852 31.6026 -2.33852 40.9704 7.02923C50.3381 16.397 50.3381 31.6026 40.9704 40.9704C31.6026 50.3381 16.397 50.3381 7.02923 40.9704ZM26.4242 23.9998L32.4851 17.9389C33.1518 17.2722 33.1518 16.1812 32.4851 15.5145C31.8184 14.8478 30.7274 14.8478 30.0607 15.5145L23.9998 21.5754L17.9389 15.5145C17.2722 14.8478 16.1812 14.8478 15.5145 15.5145C14.8478 16.1812 14.8478 17.2722 15.5145 17.9389L21.5754 23.9998L15.5145 30.0607C14.8478 30.7274 14.8478 31.8184 15.5145 32.4851C16.1812 33.1518 17.2722 33.1518 17.9389 32.4851L23.9998 26.4242L30.0607 32.4851C30.7274 33.1518 31.8184 33.1518 32.4851 32.4851C33.1518 31.8184 33.1518 30.7274 32.4851 30.0607L26.4242 23.9998Z',
      fill: 'currentColor'
    })
  }));
};
var CloseIconOutline = function CloseIconOutline(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return jsx(IconSVG, _extends({
    viewBoxWidth: 48
  }, props, {
    ref: undefined,
    children: jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.02972 7.02923C-2.33803 16.397 -2.33803 31.6026 7.02972 40.9704C16.3975 50.3381 31.6031 50.3381 40.9708 40.9704C50.3386 31.6026 50.3386 16.397 40.9708 7.02923C31.6031 -2.33852 16.3975 -2.33852 7.02972 7.02923ZM32.4856 17.9389L26.4246 23.9998L32.4856 30.0607C33.1523 30.7274 33.1523 31.8184 32.4856 32.4851C31.8189 33.1518 30.7279 33.1518 30.0612 32.4851L24.0003 26.4242L17.9394 32.4851C17.2727 33.1518 16.1817 33.1518 15.515 32.4851C14.8483 31.8184 14.8483 30.7274 15.515 30.0607L21.5759 23.9998L15.515 17.9389C14.8483 17.2722 14.8483 16.1812 15.515 15.5145C16.1817 14.8478 17.2727 14.8478 17.9394 15.5145L24.0003 21.5754L30.0612 15.5145C30.7279 14.8478 31.8189 14.8478 32.4856 15.5145C33.1523 16.1812 33.1523 17.2722 32.4856 17.9389ZM8.72678 39.2733C17.1463 47.6928 30.8543 47.6928 39.2738 39.2733C47.6933 30.8538 47.6933 17.1458 39.2738 8.72629C30.8543 0.306767 17.1463 0.306766 8.72678 8.72629C0.307256 17.1458 0.307256 30.8538 8.72678 39.2733Z',
      fill: 'currentColor'
    })
  }));
};
var CloseIcon = function CloseIcon(_ref3) {
  var weight = _ref3.weight,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded$2);
  switch (weight) {
    case 'outline':
      return jsx(CloseIconOutline, _extends({}, props));
    case 'solid':
      return jsx(CloseIconSolid, _extends({}, props));
    default:
      return jsx(Fragment, {});
  }
};

var _excluded$1 = ["cssClasses", "open", "noCircle"];
var PlusMinusLine = function PlusMinusLine(_ref) {
  var cssClasses = _ref.cssClasses,
    viewBoxCenter = _ref.viewBoxCenter;
  return jsx("line", {
    css: [{
      "transformOrigin": "center",
      "transitionDuration": "300ms"
    }, cssClasses],
    strokeLinecap: 'round',
    stroke: 'currentColor',
    strokeWidth: 1.5,
    x1: 7.5,
    y1: viewBoxCenter,
    x2: 16.5,
    y2: viewBoxCenter
  });
};
var PlusMinusIcon = function PlusMinusIcon(_ref2) {
  var cssClasses = _ref2.cssClasses,
    open = _ref2.open,
    _ref2$noCircle = _ref2.noCircle,
    noCircle = _ref2$noCircle === void 0 ? false : _ref2$noCircle,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$1);
  var transformClass = open ? {
    "--tw-rotate": "90deg",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
  } : null;
  var viewBoxSize = 24;
  var viewBoxCenter = viewBoxSize / 2;
  return jsxs(IconSVG, _extends({
    viewBoxWidth: viewBoxSize,
    cssClasses: cssClasses
  }, props, {
    ref: undefined,
    children: [jsx(PlusMinusLine, {
      viewBoxCenter: viewBoxCenter
    }), jsx(PlusMinusLine, {
      viewBoxCenter: viewBoxCenter,
      cssClasses: transformClass
    }), !noCircle && jsx("circle", {
      cx: viewBoxCenter,
      cy: viewBoxCenter,
      r: 9,
      stroke: 'currentColor',
      strokeWidth: 1.5
    })]
  }));
};

var _excluded = ["className"],
  _excluded2 = ["className"],
  _excluded3 = ["iconStyle"];
var InfoIconSolid = function InfoIconSolid(_ref) {
  var className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return jsxs(IconSVG, _extends({
    className: className,
    viewBoxWidth: 13
  }, props, {
    ref: undefined,
    children: [jsx("path", {
      d: 'M7.16861 10.2469H5.65918V6.51409H7.16861V10.2469ZM6.4139 5.4328C6.07942 5.4328 5.77762 5.23132 5.64992 4.92201C5.52178 4.61315 5.59292 4.25701 5.82976 4.02061C6.06615 3.78421 6.4223 3.71396 6.73116 3.8421C7.04003 3.97068 7.24107 4.27247 7.24063 4.60696C7.24063 4.82612 7.15358 5.03645 6.99849 5.19155C6.8434 5.3462 6.63307 5.43324 6.4139 5.4328Z',
      fill: 'currentColor'
    }), jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.4158 12.2194L6.41694 12.2194C7.79493 12.2221 9.11876 11.6748 10.0955 10.7012C11.0715 9.72486 11.6194 8.40093 11.6194 7.02142V7.01993C11.6221 4.91427 10.3567 3.01412 8.41199 2.20424C6.46656 1.39742 4.22457 1.84075 2.73773 3.32759L2.737 3.32832C1.2456 4.81701 0.798331 7.0593 1.60449 9.00247L1.60524 9.00426C2.40877 10.9506 4.30833 12.2194 6.41466 12.2194H6.4158ZM8.84607 1.15967C11.2132 2.14508 12.7539 4.45798 12.7505 7.02142C12.7505 8.70105 12.0834 10.313 10.8948 11.5016C9.70621 12.6868 8.09429 13.3539 6.41466 13.3505C3.85122 13.3505 1.53832 11.8064 0.559668 9.43593C-0.422363 7.06884 0.122824 4.33948 1.93787 2.52773C3.74953 0.716072 6.47898 0.177637 8.84607 1.15967Z',
      fill: 'currentColor'
    })]
  }));
};
var InfoIconOutline = function InfoIconOutline(_ref2) {
  var className = _ref2.className,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return jsxs(IconSVG, _extends({
    className: className,
    viewBoxWidth: 13
  }, props, {
    ref: undefined,
    children: [jsx("path", {
      d: 'M7.16861 9.57166H5.65918V5.8388H7.16861V9.57166ZM6.4139 4.75751C6.07942 4.75751 5.77762 4.55603 5.64992 4.24672C5.52178 3.93785 5.59292 3.58172 5.82976 3.34531C6.06615 3.10892 6.4223 3.03866 6.73116 3.1668C7.04003 3.29538 7.24107 3.59718 7.24063 3.93167C7.24063 4.15083 7.15358 4.36116 6.99849 4.51625C6.8434 4.67091 6.63307 4.75795 6.4139 4.75751Z',
      fill: 'currentColor'
    }), jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.4158 11.5441L6.41694 11.5441C7.79493 11.5468 9.11876 10.9995 10.0955 10.0259C11.0715 9.04957 11.6194 7.72563 11.6194 6.34613V6.34464C11.6221 4.23897 10.3567 2.33883 8.41199 1.52894C6.46656 0.722129 4.22457 1.16546 2.73773 2.6523L2.737 2.65302C1.2456 4.14171 0.798331 6.38401 1.60449 8.32717L1.60486 8.32807L1.60524 8.32897C2.40877 10.2753 4.30833 11.5441 6.41466 11.5441H6.4158ZM8.84607 0.484375C11.2132 1.46979 12.7539 3.78269 12.7505 6.34613C12.7505 8.02576 12.0834 9.63768 10.8948 10.8263C9.70621 12.0115 8.09429 12.6786 6.41466 12.6752C3.85122 12.6752 1.53832 11.1311 0.559668 8.76064C-0.422363 6.39355 0.122824 3.66418 1.93787 1.85244C3.74953 0.0407794 6.47898 -0.497656 8.84607 0.484375Z',
      fill: 'currentColor'
    })]
  }));
};
var InfoIcon = function InfoIcon(_ref3) {
  var _ref3$iconStyle = _ref3.iconStyle,
    iconStyle = _ref3$iconStyle === void 0 ? 'solid' : _ref3$iconStyle,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  switch (iconStyle) {
    case 'solid':
      return jsx(InfoIconSolid, _extends({}, props));
    case 'outline':
      return jsx(InfoIconOutline, _extends({}, props));
    default:
      return jsx(Fragment, {});
  }
};

var NotesIcon = function NotesIcon(_ref) {
  _objectDestructuringEmpty(_ref);
  return jsxs(IconSVG, {
    viewBoxWidth: 520.7,
    viewBoxHeight: 588.6,
    children: [jsx("path", {
      fill: 'currentColor',
      d: 'M433.4,539.4c-0.3,0-0.7,0-1,0c-18.7-0.1-36.4-10.3-48.4-24.5c-6.1-7.3-11-15.7-18.1-22.1c-16.7-15.1-41.6-15.8-64.1-15.7c-62.7,0.3-125.3,0.7-188,1c-12.8,0.1-25.7,0.1-38.5,0.2c-4.7,0-13.3,1.8-17.1-1.2c-3.4-2.7-3.5-8.9-3.5-12.8c0.1-98.5,0.1-197,0.2-295.6c0-5.4,0.1-10.9,2.4-15.7c1.7-3.6,4.6-6.5,7.4-9.3c28.3-28.1,56.6-56.2,84.9-84.3c3-3,6.1-6,9.8-7.9c5.4-2.7,11.8-2.8,17.9-2.8c74,0,147.9,0,221.9,0c5.4,0,11.6,0.4,14.9,4.6c2.4,3.1,2.6,7.4,2.6,11.3c0.9,107.7,0.5,215.3-0.9,323c-0.1,7.7-0.2,15.6,2.9,22.6c3.1,7.1,9,12.5,14.8,17.7c12.4,10.9,25.4,21.7,34.4,35.5c9.1,13.8,13.8,31.6,8.3,47.1C470.2,528,451.8,539.1,433.4,539.4z M168,153.6c-0.1,3.1-0.5,8.3-2.8,8.3c-16.8,0.1-33.5,0.1-50.3,0c-8.8,0-17.7,0-26.5,0c-3.2,0-16.4-1.7-18.5,1.4c-0.6,0.8-0.6,1.9-0.7,2.9c-0.3,11.8,0.6,24,0.6,35.5c0,21.5-0.1,43-0.2,64.6c-0.3,63.7-0.8,127.4-0.6,191.1c0,0.5,0.5,0.9,0.8,1.4c0,0.2,0,0.5,0,0.7c-0.2,0.1-0.4,0.2-0.6,0.4c0.3,1,0.6,2,0.9,3.1c0.4,1.2,1,1.4,1.6,0.1c0.4,0,0.8,0.1,1.2,0.1c0.7,0.1,1.4,0.2,2.1,0.3c1.1,0.1,2.1,0.3,3.2,0.3c78.9,0,157.8,0,236.7,0c2.2,0,4.3,0,6.5,0c1.9-0.2,3.8-0.5,5.7-0.7c0.2-0.2,0.4-0.4,0.5-0.5c0,0,0,0,0,0c1.2,0.2,0.6,0.7,1.6,0.7c0.4-3.4-3.4-6.9-5.7-9.4c-16.5-18.2-34.3-35.1-51.9-52.2c-7.9-7.7-18.2-15.5-22.4-26c-1-2.6-1.7-5.3-2.4-8c-2.4-9.8-4.8-19.6-7.1-29.4c-0.7-3-1.5-6-1.8-9.1c-0.8-7.6-3.8-14.2-5.6-21.8c-1.5-6.4-2.1-13.8,6.4-14.3c2.8-0.2,5.6,0.6,8.3,1.3c11.9,3.2,23.8,6,35.9,8.5c10,2.1,21.1,2.7,30.3,7.1c2.3,1.1,4.6,2.2,6.8,3.3c2.7,1.3,6.4,6.8,8.6,9.1c1,0.1,1.8,0.9,2.1,1.9c7.9,7.3,16.6,15.5,23.7,23.5c10,11.5,20.7,22.3,32.1,32.4c2.1,1.9,11.2,14.4,14.9,10.1c0.9-1,0.9-2.6,0.9-3.9c0-10.5-0.1-21.1-0.1-31.6c0-19.1-0.2-38.1-0.2-57.2c0.1-76,0.2-152.1,0.4-228.1c0-8.8-8.9-6.2-15.1-6.2c-9.2-0.1-18.4-0.3-27.7-0.3c-5.7,0-11.5,0.4-17.2,0.4c-56,0-111.9,0-167.9,0c-1.4,0-2.8,0.3-4.2,0.4c-0.6-0.1-1.6-0.5-1.8-0.4c-0.6,0.9-0.9,1.9-1.3,2.9c-1.7,4-0.2,13.4-0.2,17.9c0,7.5,0.1,15,0.1,22.4c0.1,15,0.2,29.9,0.3,44.9C168,152,168,152.7,168,153.6zM464.6,499.4c1.4-9.3-1-19.5-5.3-28.1c-0.9-1.8-2.3-3.8-4.3-3.7c-1.4,0.1-2.4,1.1-3.4,2c-13.4,13.4-26.7,26.8-40.1,40.2c-8.1,8.1,1.8,12.8,9.2,15c8,2.4,16.9,2.1,24.6-1.1c5.9-2.5,11.2-6.6,14.7-11.9C462.4,508,463.9,503.8,464.6,499.4z M273,314.5c-6.1-1.3-12.2-2.6-18.3-4c-1.6-0.3-3.4-0.6-4.6,0.4c-1.3,1.2-1.1,3.3-0.8,5c2.2,11.5,4.6,22.9,7.3,34.3c1.3,5.6,3.8,11.4,9.5,5.7c9.8-9.9,19.6-19.8,29.4-29.6c1.7-1.7,3.4-4.5,1.6-6.1c-0.6-0.6-1.4-0.7-2.2-0.9C287.6,317.6,280.3,316.1,273,314.5z M294.3,346.9c-8.9,8.9-17.8,17.8-26.7,26.7c-0.5,0.5-1.1,1.2-1.1,1.9c0,0.8,0.6,1.4,1.1,1.9c21.7,21.3,43,42.7,64.3,64.4c10.6,10.8,21.3,21.6,32,32.3c5.5,5.5,10.9,10.9,16.4,16.3c1.5,1.5,14.8,16.1,15.9,15.6c15.5-14.6,30.5-29.6,45-45.1c0.8-0.9,1.7-1.8,2-3c0.5-2.3-1.3-4.4-3-6.1c-41.5-41.3-83.1-82.6-124.6-123.9c-0.2-0.2-0.5-0.5-0.8-0.5c-0.3,0-0.6,0.2-0.9,0.4C306.9,333.5,300.7,340.5,294.3,346.9z M122,107c0,0.1,0.1,0.3,0.2,0.4c-0.2,0.4-0.4,0.7-0.7,1.1c-0.4-0.2-0.9-0.3-1.3-0.5c-1.7-0.7-2.2-0.2-1.5,1.5c-0.5,0.4-1,0.7-1.4,1.1c-0.3-0.1-0.7-0.1-1-0.2c0,0.4,0,0.8,0,1.2c-0.6,1.1-1.2,2.1-1.8,3.2c-0.4,0.1-0.9,0.2-1.3,0.3c-1.9-0.2-2.7,0.6-2.5,2.5c-0.3,0.5-0.7,0.9-1,1.4c-0.4-0.2-0.7-0.5-1.1-0.7c-0.1,0.4-0.2,0.9-0.4,1.3c-0.5,0.3-1.1,0.5-1.5,0.9c-4.3,4.2-8.5,8.5-12.7,12.8c-1.1,1.1-1.9,2.5-2.9,3.8c-1.3,1-2.7,1.9-3.9,3.1c-1.3,1.4-2.4,3-3.5,4.5c-0.2,0.3-0.4,0.5-0.6,0.8c-1.2-1.4-1.7-0.7-1.9,0.7c0,0.8,0,1.6,0,2.4c-0.1,2.4,1.6,2.5,3.4,2.5c21.9,0,43.8,0,65.7,0c0.7,0,1.7,0.1,2.2-0.3c0.8-0.6,2.7-1.2,0.8-2.7c0-0.5-0.1-1-0.1-1.6c0.1-0.9,0.3-1.8,0.3-2.7c0-11.7,0-23.5-0.1-35.2c-0.1-8.1-0.2-16.1-0.3-24.2c0.3-0.5,0.5-1,0.8-1.6c0.1-1.5,0.5-3.1,0.3-4.5c-0.1-0.9-1.2-1.7-1.9-2.6c-0.6,0.8-1.3,1.7-1.9,2.5c-0.1,0-0.2,0-0.3,0c-1.6-0.4-2.3,0.3-2.3,1.8c-1.8,1.7-3.5,3.3-5.3,5.1c-5.9,5.8-11.8,11.7-17.7,17.5c-0.3,0.5-0.7,0.9-1,1.4c-0.3,0.3-0.7,0.7-1,1c-0.6,0.3-1.2,0.6-1.8,0.9C121.3,106.2,121.7,106.6,122,107z'
    }), jsx("path", {
      fill: 'currentColor',
      d: 'M183.7,214.9c-12.6,0-25.2-0.2-37.8-0.5c-1.6,0-18.7-0.2-18.7-0.6c-0.3-2.9-2.6-3-4.7-3.3c-1.1-3.3-1.2-6.5,0.9-9.4c1.6-0.7,3.3-1.4,4.9-2.1c71.9,2,144.3-0.7,216.2,0.9c5,0.1,6.8,7.8,4.8,11.3c-2.6,4.6-9.6,3.9-13.9,3.9c-7.5-0.1-15-0.1-22.5-0.2C269.8,214.7,226.8,215,183.7,214.9z'
    }), jsx("path", {
      fill: 'currentColor',
      d: 'M344.8,263.4c-0.3,0.2-0.7,0.4-1,0.6c-72.2-1.1-144.7-0.2-217-0.3c-1-1.3-1.2-3.7-3.5-3c-0.4,0-0.7,0-1.1,0c-0.3-1.6,0.1-3.3,0-4.9c0-4.4,0.8-5.5,5.1-6.8c5.6-1.8,14.6-0.1,20.5,0c7.1,0.1,14.3,0.2,21.4,0.3c48.1,0.3,96.2,0.2,144.3,0.2c9.7,0,19.7-1.3,29.4-0.8C352.7,249,350.7,258.8,344.8,263.4z'
    }), jsx("path", {
      fill: 'currentColor',
      d: 'M126.5,298.3c2-0.8,4.5-0.9,6.7-0.9c14.7,0,29.5-0.1,44.2-0.1c3.6,0,7.3,0,10.4,1.7c3.1,1.7,5.4,5.5,4.1,8.8c-1.6,3.9-6.7,4.6-10.9,4.7c-13,0.2-25.9,0.3-38.9,0.2c-4.8,0-12.7,1.5-16.7-1.6c-3.1-2.4-4.5-7.9-1.7-11C124.6,299.3,125.5,298.7,126.5,298.3z'
    })]
  });
};

var XIcon = function XIcon(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(IconSVG, _extends({
    viewBoxWidth: 20,
    viewBoxHeight: 19
  }, props, {
    ref: undefined,
    children: jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10 7.05484L17.054 0L19.5 2.46926L12.4685 9.5L19.5 16.554L17.054 19L10 11.9685L2.96926 19L0.5 16.554L7.55484 9.5L0.5 2.46926L2.96926 0L10 7.05484Z',
      fill: 'currentColor'
    })
  }));
};

export { CaretIcon, CheckMarkIcon, ChevronIcon, CloseIcon, IconSVG, InfoIcon, NotesIcon, PlusMinusIcon, XIcon };
//# sourceMappingURL=index.esm.js.map
